import { render, staticRenderFns } from "./AddCourseImage.vue?vue&type=template&id=50c6dc3b&scoped=true"
import script from "./AddCourseImage.vue?vue&type=script&lang=js"
export * from "./AddCourseImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6dc3b",
  null
  
)

export default component.exports